<template>
  <section>
    <h3 class="primary--text">
      <router-link class="no-link-style" style="font-weight:500" :to="{ name: 'Case', params: { case_id: eventDateObj.caseId} }">{{ eventDateObj.title }}</router-link>
      {{ text }}
      <a :href="getApiEndPoint + eventDateObj.params.url" class="no-link-style" style="font-weight:500" >{{ eventDateObj.params[activityValue] }}</a>
      {{ activityLabel }}
    </h3>
  </section>
</template>

<script>
import { lookupByEventType } from "@/stores/timeline/eventTypes"
import { mapGetters } from 'vuex'

export default {
  name: "DoublePrefixTitle",
  data: () => ({
    activity: {
      "document.updated": "updated",
      "document.deleted": "deleted"
    },
    activityValues: {
      "document.updated": "filename",
      "document.deleted": "filename"
    }
  }),
  props: ["eventDateObj", "text"],
  components: {
  },
  methods: {
  },
  computed: {
    ...mapGetters({
      getApiEndPoint: 'getApiEndPoint'
    }),
    activityValue() {
      return lookupByEventType(this.activityValues, this.eventDateObj.activity)
    },
    activityLabel() {
      return lookupByEventType(this.activity, this.eventDateObj.activity)
    }
  }
}
</script>
